const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const publicUrl = new URL(
      process.env.PUBLIC_URL || "",
      window.location.href
    );

    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log("Service Worker registrado em localhost");
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl, { scope: "./" })
    .then((registration) => {
      console.log("Service Worker registrado com sucesso:", registration);

      // Verifica atualizações periodicamente
      setInterval(() => {
        registration.update();
      }, 60 * 60 * 1000); // A cada 1 hora

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log("Nova versão disponível!");

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log("Conteúdo está em cache para uso offline.");

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error("Erro durante o registro do Service Worker:", error);
    });

  // Escuta mudanças no controller
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!refreshing) {
      refreshing = true;
      console.log("Controller mudou, recarregando página...");
      window.location.reload();
    }
  });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log("Sem conexão com a internet. App rodando offline.");
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}

// Funções auxiliares para limpar cache
export async function clearServiceWorkerCache() {
  if ("serviceWorker" in navigator) {
    try {
      // Envia mensagem para o Service Worker limpar cache
      const registration = await navigator.serviceWorker.ready;
      const sw = registration.active;

      if (sw) {
        const channel = new MessageChannel();
        sw.postMessage({ type: "CLEAR_CACHE" }, [channel.port2]);

        return new Promise((resolve) => {
          channel.port1.onmessage = (event) => {
            if (event.data.type === "CACHE_CLEARED") {
              resolve(true);
            }
          };
        });
      }
    } catch (error) {
      console.error("Erro ao limpar cache:", error);
      return false;
    }
  }
  return false;
}

export async function forceUpdate() {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.ready;

      // Limpa todos os caches
      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map((name) => caches.delete(name)));
      }

      // Limpa storages
      localStorage.clear();
      sessionStorage.clear();

      // Desregistra o Service Worker
      await registration.unregister();

      // Recarrega
      window.location.reload();
    } catch (error) {
      console.error("Erro no force update:", error);
    }
  }
}
